import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Pagination } from '@material-ui/lab'
import React from 'react'

import NoDataImage from '../../assets/images/No-Data.png'
import { Booking } from '../../types/booking'
import { BookingsListTableHeader } from './BookingsListTableHeader'
import { BookingsListTableRow } from './BookingsListTableRow'
import { BookingsListTableRowSkeleton } from './BookingsListTableRow.skeleton'
import useStyles from './styles/BookingsListTable.styles'

interface BookingListTableProps {
  data: Booking | undefined
  loadingForGetBookingList: boolean
  page: number
  setPage(page: number): void
  hasAccessToViewBookingDetails: boolean | undefined
  hasAccessToEditBookingDetails: boolean | undefined
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      bookingList: Booking
    }>
  >
}
export const BookingsListTable: React.FC<BookingListTableProps> = ({
  data,
  loadingForGetBookingList,
  page,
  setPage,
  hasAccessToViewBookingDetails,
  hasAccessToEditBookingDetails,
  refetch
}) => {
  const classes = useStyles()

  return (
    <div>
      <BookingsListTableHeader setPage={setPage} refetch={refetch} />
      {loadingForGetBookingList ? (
        Array(8)
          .fill('')
          .map((_, skeletonIndex) => (
            <BookingsListTableRowSkeleton key={skeletonIndex} />
          ))
      ) : data && data.bookingsList.length > 0 ? (
        data?.bookingsList.map((item, index) => (
          <BookingsListTableRow
            key={index}
            data={item}
            hasAccessToViewBookingDetails={hasAccessToViewBookingDetails}
            hasAccessToEditBookingDetails={hasAccessToEditBookingDetails}
            isOdd={index % 2 !== 0}
          />
        ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt="no_booking_list" />
        </div>
      )}
      <div className={classes.paginationContainer}>
        <Pagination
          count={data?.pageInfo.lastPage}
          color="primary"
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
